import styles from './googleLinkedStatusSection.module.scss'

/** Shown in My Account when Google sign-in is already linked (replaces the “Link with Google” row). */
const GoogleLinkedStatusSection = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Google sign-in</h2>
      <p className={styles.success}>
        Google is linked to this account. You can sign in with Google or your RallyPD password.
      </p>
    </div>
  )
}

export default GoogleLinkedStatusSection
